/* eslint-disable jsx-a11y/interactive-supports-focus */
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _reduce from 'lodash/reduce';
import _keys from 'lodash/keys';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { ddRum, rumErrorCtx, SEVERITY } from '@web-platform/browser-rum';
import classnames from 'classnames';
import { Button, Icon, Select, Progress } from 'grab-ui';
import BulkReviewTable from 'components/v2/bulk-review-table/bulk-review-table';
import ReviewOrderEditModal from 'components/v2/bulk-review-table/review-order-edit-modal';
import SelectLocationModal from 'components/v2/select-location-modal/select-location-modal';
import MultipleSelect from 'components/v2/multiple-select-with-checkbox/multiple-select';
import BackButton from 'components/v2/back-button/back-button';
import { getCompanyID, isUsingPaxPersonalPayments } from 'helper/user';
import {
  validateBookingLimit,
  updateReviewOrders,
  updateReviewOrderLocation,
  getUpdateErrFieldOriginalValue,
  getDeliveryDetails,
  isOrderWithValidQuote,
} from 'helper/bulk-upload';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import {
  addNotification,
  removeNotification,
  NOTIFICATION_TYPE,
} from 'components/notification/notification';
import NOTIFICATION_CONFIGS, {
  customizedTextNotificationConfig,
} from 'components/notification/notification-configs';
import { userInfoSelector } from 'selectors/app-selector';
import classifyWord from 'common/utils/classify-word';
import { getAmountDisplay } from 'helper/order';
import { getQuotaMap, enterpriseForQuoteParam } from 'helper/quote';
import { getDefaultErrorContext } from 'common/utils/rum-utils';
import { pushGAPageViewEvent } from 'helper/ga-helper';
import {
  GA_CATEGORY,
  GA_ACTION,
  GA_EVENT,
  BOOKING_TRANSACTION,
} from 'constants/ga-constants';
import {
  getQuotesAction,
  createOrderAction,
  getAddressTranslationAction,
  getPaymentMethodsAction,
  fetchServiceTypesAction,
  getAddressSearchAction,
  clearOrdersActionV2,
} from 'actions/booking-actions';
import {
  TABLE_COLUMN_V2,
  TABLE_COLUMN_V2_MUST_SHOW,
  BULK_CREATE_SIZE,
} from 'constants/bulk-upload-constants';
import { BookingMode } from 'constants/booking-constants';
import { showFailedPaymentsRetryModalAction } from 'actions/app-actions';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_STATE_NAMES,
  SCRIBE_BULK_UPLOAD_REVIEW_EVENTS,
  SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS,
  SCRIBE_EVENT_PARAMS,
} from 'applications/scribe/instrumentations/track';

import ScribeDuck from 'ducks/scribe-duck.js';

import css from './bulk-upload-page.less';

const Option = Select.Option;
const STATUS_FILTERS = {
  ALL: 'allStatus',
  VALID: 'valid',
  INVALID: 'invalid',
};

class BulkUploadPage extends Component {
  constructor(props) {
    super(props);
    const { initReviewParams } = props;
    const {
      reviewOrders,
      quoteParam,
      serviceTypeMap,
      paymentMethodMap,
      addressMap,
      bookingLimitValidation,
    } = initReviewParams;

    this.state = {
      visibleSelectPOIModal: false,
      visibleUpdateErrFieldModal: false,
      visibleColumns: _keys(TABLE_COLUMN_V2),
      statusFilter: STATUS_FILTERS.ALL,
      // review orders params
      reviewOrders: validateBookingLimit(reviewOrders, bookingLimitValidation),
      quoteParam,
      serviceTypeMap,
      paymentMethodMap,
      addressMap,
      fetchingQuote: false,
      isCreatingOrders: false,
      batchedDeliveriesCount: 0,
      placedBatchDeliveriesCount: 0,
      bookingLimitValidation,
    };
    this.editingAddressOrder = null;
    this.editingErrorOrder = null;
  }

  getOrdersBatchRef(orders) {
    // filter out the MSD
    const orderBatchRefs = orders
      .filter(order => !!_get(order, 'batchReference'))
      .map(order => {
        const stop = order.itinerary.filter(iter => iter.itineraryIndex !== 0);
        const res = stop.map(s =>
          order.batchReference.concat('-').concat(String(s.sequenceNumber)),
        );
        return res;
      })
      .flat();

    return orderBatchRefs;
  }

  getOrderBatchRef(order, itineraryIndex) {
    if (_get(order, 'batchReference')) {
      if (itineraryIndex === 0) {
        return order.batchReference;
      }
      return order.batchReference
        .concat('-')
        .concat(_get(order, ['itinerary', itineraryIndex, 'sequenceNumber']));
    }
    return '';
  }

  getBookingNumbersIndex(orders) {
    return orders
      .filter(order => !!_get(order, 'index'))
      .map(order => order.index);
  }

  componentDidMount() {
    const { userInfo, scribeExpressBulkUploadReviewDefault } = this.props;
    const { initReviewParams } = this.props;
    const { reviewOrders } = initReviewParams;

    pushGAPageViewEvent('REVIEW', userInfo);

    scribeExpressBulkUploadReviewDefault(
      reviewOrders.length,
      this.getOrdersBatchRef(reviewOrders),
      Array.from({ length: reviewOrders.length }, (_, i) => i + 1),
    );
  }

  componentWillUnmount() {
    this.editingErrorOrder = null;
    this.editingAddressOrder = null;
  }

  onDeleteRecord = index => e => {
    e.preventDefault();

    const { reviewOrders, bookingLimitValidation } = this.state;
    const { userInfo } = this.props;
    const newReviewOrders = reviewOrders.filter(
      (o, orderIndex) => index !== orderIndex,
    );

    const selectedDeleteOrder = reviewOrders.filter(
      (o, orderIndex) => index === orderIndex,
    )[0];

    trackClick(
      event.BULK_UPLOAD_REVIEW_CLICKS,
      cat.GE_BULK_UPLOAD_REVIEW,
      'DELETE_DELIVERY',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.DELETE_DELIVERY,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.BULK_DELIVERY_REFERENCE_CODE]: _get(
          selectedDeleteOrder,
          'batchReference',
        ),
      },
    });

    const newBookingLimitReviewOrders = validateBookingLimit(
      newReviewOrders,
      bookingLimitValidation,
    );

    this.setState({
      reviewOrders: newBookingLimitReviewOrders.map((order, orderIndex) => ({
        ...order,
        orderId: orderIndex,
      })),
    });
  };

  onClickRepickLocation = ({
    order,
    itineraryIndex,
    disabled = false,
    originalAddressEntity,
    isSender = false,
  }) => e => {
    e.preventDefault();

    if (disabled) return;

    this.editingAddressOrder = {
      order,
      itineraryIndex,
      originalAddressEntity,
      isSender,
    };
    const { userInfo, scribeExpressBulkUploadReviewEditAddress } = this.props;
    trackClick(
      event.BULK_UPLOAD_REVIEW_CLICKS,
      cat.GE_BULK_UPLOAD_REVIEW,
      'EDIT_ADDRESS',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );

    const orderBatchRef = this.getOrderBatchRef(order, itineraryIndex);

    scribeExpressBulkUploadReviewEditAddress(
      _get(originalAddressEntity, 'input'),
      _get(originalAddressEntity, 'address'),
      isSender,
      orderBatchRef,
    );

    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.DEFAULT,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.STEP_TYPE]: isSender ? 'PICKUP' : 'DROPOFF',
        [SCRIBE_EVENT_PARAMS.BULK_DELIVERY_REFERENCE_CODE]: orderBatchRef,
      },
    });
    this.setState({ visibleSelectPOIModal: true });
  };

  onClickCancelRepickLocation = e => {
    e.preventDefault();
    const { userInfo } = this.props;
    trackClick(
      event.BULK_UPLOAD_EDIT_ADDRESS_PV,
      cat.GE_BULK_UPLOAD_EDIT_ADDRESS,
      'CANCEL',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );
    const { originalAddressEntity } = this.editingAddressOrder;

    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.CANCEL,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.BULK_EDIT_ORIGINAL]: _get(
          originalAddressEntity,
          'address',
        ),
      },
    });

    this.editingAddressOrder = {};
    this.setState({ visibleSelectPOIModal: false });
  };

  onClickUpdateRepickLocation = newLocation => {
    const { fetchQuotes, userInfo } = this.props;
    const {
      serviceTypeMap,
      addressMap,
      paymentMethodMap,
      reviewOrders,
    } = this.state;
    const currentQuoteParam = _get(this.state, 'quoteParam');
    const {
      order: { quoteRequestID: prevQuoteRequestID, orderId },
      itineraryIndex,
    } = this.editingAddressOrder;

    const originalLocation = _get(
      this.editingAddressOrder,
      `order.itinerary[${itineraryIndex}]`,
      {},
    );

    // track locationnotes update
    if (newLocation.instruction !== originalLocation.instruction) {
      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
        eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.LOCATION_NOTES,
        facets: getCommonFacet(userInfo),
      });
    }

    // append new location to address map
    const newAddressMap = { ...addressMap };
    if (!newAddressMap[newLocation.keywords]) {
      newAddressMap[newLocation.keywords] = {
        address: {
          name: newLocation.keywords,
          combined_address: newLocation.address,
        },
        grabtaxi: {
          city_id: newLocation.cityID,
        },
        id: newLocation.poiID,
        input: newLocation.keywords,
        latlng: newLocation.coordinates,
      };
    }

    const {
      validatedOrder,
      newQuoteDelivery,
      serviceEntity,
    } = updateReviewOrderLocation({
      newLocation,
      updatingOrderMeta: this.editingAddressOrder,
      serviceTypeMap,
      addressMap: newAddressMap,
      paymentMethodMap,
    });

    const newReviewOrders = reviewOrders.map(
      (order, index) => (index === orderId ? validatedOrder : order),
    );

    // replace updated order's quote param
    const { deliveries: newDeliveries = [] } = currentQuoteParam;
    const newQuoteExistedIndex = _get(
      currentQuoteParam,
      'deliveries',
      [],
    ).findIndex(quote => quote.quoteRequestID === prevQuoteRequestID);

    if (newQuoteExistedIndex === -1) {
      if (!_isEmpty(newQuoteDelivery)) {
        newDeliveries.push(newQuoteDelivery);
      }
    } else if (!_isEmpty(newQuoteDelivery)) {
      newDeliveries.splice(newQuoteExistedIndex, 1, newQuoteDelivery);
    } else {
      newDeliveries.splice(newQuoteExistedIndex, 1);
    }

    const newQuoteParam = {
      enterprise: currentQuoteParam.enterprise,
      deliveries: newDeliveries,
      serviceTypes: currentQuoteParam.serviceTypes.concat({
        serviceID: serviceEntity.ID,
        expressServiceID: serviceEntity.expressServiceID,
        serviceTypeName: serviceEntity.name,
      }),
    };

    if (_isEmpty(newQuoteDelivery)) {
      this.setState({
        visibleSelectPOIModal: false,
        quoteParam: newQuoteParam,
        reviewOrders: newReviewOrders,
        addressMap: newAddressMap,
      });
    } else {
      const quoteParamForUpdatedOrder = {
        ...newQuoteParam,
        deliveries: [newQuoteDelivery],
      };

      this.setState({
        visibleSelectPOIModal: false,
        quoteParam: newQuoteParam,
        fetchingQuote: true,
        addressMap: newAddressMap,
      });

      fetchQuotes(quoteParamForUpdatedOrder, quotes => {
        const quoteItem = _get(quotes, 'deliveries[0].quotes[0]') || {};
        newReviewOrders[orderId] = {
          ...validatedOrder,
          amount: quoteItem.amount ? quoteItem.amount : 0,
          currency: quoteItem.currency,
          quote: quoteItem,
        };
        this.setState({
          reviewOrders: newReviewOrders,
          fetchingQuote: false,
        });
      });
    }
  };

  onVisibleColumnsChanged = visibleColumns => {
    const { userInfo } = this.props;
    trackClick(
      event.BULK_UPLOAD_REVIEW_CLICKS,
      cat.GE_BULK_UPLOAD_REVIEW,
      'SELECT_COLUMNS',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.SELECT_COLUMNS,
      facets: getCommonFacet(userInfo),
    });

    this.setState({
      visibleColumns,
    });
  };

  onStatusFilterChange = status => {
    const { userInfo } = this.props;
    trackClick(
      event.BULK_UPLOAD_REVIEW_CLICKS,
      cat.GE_BULK_UPLOAD_REVIEW,
      'SELECT_STATUS',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.SELECT_STATUS,
      facets: getCommonFacet(userInfo),
    });

    this.setState({
      statusFilter: status,
    });
  };

  onEditErrorField = (orderIndex, fieldKey, itineraryIndex) => {
    this.editingErrorOrder = {
      orderIndex,
      fieldKey,
      itineraryIndex,
    };
    this.setState({
      visibleUpdateErrFieldModal: true,
    });
  };

  onCancelEditErrorField = () => {
    this.setState({
      visibleUpdateErrFieldModal: false,
    });
    this.editingErrorOrder = null;
  };

  onEditErrorFieldSave = newValue => {
    if (this.editingErrorOrder) {
      const {
        reviewOrders,
        serviceTypeMap,
        addressMap,
        paymentMethodMap,
      } = this.state;
      const { fetchQuotes } = this.props;
      const { orderIndex, fieldKey, itineraryIndex } = this.editingErrorOrder;

      const currentQuoteParam = _get(this.state, 'quoteParam');
      const errorOrder = reviewOrders[orderIndex];

      // update order, get new newQuoteDelivery
      const { updatedReviewOrders, newQuoteDelivery } = updateReviewOrders({
        orders: reviewOrders,
        updateOrderIndex: orderIndex,
        fieldKey,
        newValue,
        itineraryIndex,
        orderMeta: {
          serviceTypeMap,
          addressMap,
          paymentMethodMap,
        },
      });
      const prevQuoteRequestID = errorOrder.quoteRequestID;

      // Replace the old fetch quote params of the edited order
      const editedOrderNewFetchQuote = {
        ...currentQuoteParam,
        // use the new newQuoteDelivery for edited order to fetch new quote later
        deliveries: newQuoteDelivery ? [newQuoteDelivery] : [],
      };

      let newQuoteDeliveries = [];
      if (_isEmpty(currentQuoteParam.deliveries)) {
        newQuoteDeliveries = editedOrderNewFetchQuote.deliveries;
      } else {
        newQuoteDeliveries = currentQuoteParam.deliveries.reduce(
          (acc, delivery) => {
            if (delivery.quoteRequestID !== prevQuoteRequestID) {
              acc.push(delivery);
              return acc;
            }
            // delivery.quoteRequestID === prevQuoteRequestID
            if (newQuoteDelivery) {
              acc.push(newQuoteDelivery);
            }
            return acc;
          },
          [],
        );
      }

      const updatedQuoteParam = {
        ...currentQuoteParam,
        deliveries: newQuoteDeliveries,
      };

      // close edit modal, update orders to be rendered for review table,
      // start fetch quote for updated order
      this.setState({
        visibleUpdateErrFieldModal: false,
        reviewOrders: updatedReviewOrders,
        quoteParam: updatedQuoteParam,
        fetchingQuote: true,
      });
      this.editingErrorOrder = null;

      // fetch quote for the edited order
      fetchQuotes(editedOrderNewFetchQuote, quotes => {
        const quoteItem = _get(quotes, 'deliveries[0].quotes[0]') || {};
        // update the edited order with newly fetched quotes
        updatedReviewOrders[orderIndex] = {
          ...updatedReviewOrders[orderIndex],
          amount: _get(quoteItem, 'amount', 0),
          currency: _get(quoteItem, 'currency', {}),
          quote: quoteItem,
        };
        this.setState({
          fetchingQuote: false,
          reviewOrders: updatedReviewOrders,
        });
      });
    }
  };

  onClickBookDeliveries = () => {
    const { userInfo, createOrder, fetchQuotes } = this.props;
    const { reviewOrders, quoteParam } = this.state;

    // Add index for SCRIBE tracking
    reviewOrders.forEach((row, index) => {
      row.index = index + 1;
    });
    const validItems = this.filterValidItems(reviewOrders);

    if (_isEmpty(reviewOrders)) return;
    trackClick(event.DELIVERY_DETAILS_CLICKS, cat.GE_DELIVERY_DETAILS, 'BOOK', {
      [custom.COMPANY_ID]: getCompanyID(userInfo),
      TOTAL_DELIVERIES: reviewOrders.length,
    });
    const { totalAmount, currency } = this.getTotalAmountAndCurrency();
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.BOOK,
      facets: {
        ...getCommonFacet(userInfo),
        [SCRIBE_EVENT_PARAMS.FARE]: totalAmount,
        [SCRIBE_EVENT_PARAMS.CURRENCY]: _get(currency, 'code'),
        [SCRIBE_EVENT_PARAMS.BULK_DELIVERY_TOTAL]: validItems.length,
        [SCRIBE_EVENT_PARAMS.BULK_DELIVERY_REFERENCE_CODE]: this.getOrdersBatchRef(
          validItems,
        ),
        [SCRIBE_EVENT_PARAMS.BULK_BOOKING_NUMBER]: this.getBookingNumbersIndex(
          validItems,
        ),
      },
    });

    const { countryCode, cityCode } = userInfo.selectedCity;

    fetchQuotes(quoteParam, async quotes => {
      // forming deliveries object as a param for createOrder APIs
      const deliveries = this.getCreateOrderDeliveries(
        reviewOrders,
        quotes,
        countryCode,
        cityCode,
      );
      let errorsDeliveries = {};
      let succeessCreatedOrderCount = 0;

      // showing Spinner and process's percentages while uploading
      this.setState({
        batchedDeliveriesCount: deliveries.length,
        placedBatchDeliveriesCount: 0,
        isCreatingOrders: true,
      });
      // Place order by batch of [BULK_CREATE_SIZE]
      for (let i = 0; i < deliveries.length; i += BULK_CREATE_SIZE) {
        // each sending request will contain [BULK_CREATE_SIZE] of orders
        const slicedDeliveries = deliveries.slice(i, i + BULK_CREATE_SIZE);
        // eslint-disable-next-line no-await-in-loop
        await createOrder(
          this.createOrderParams(slicedDeliveries, userInfo),
          // eslint-disable-next-line no-loop-func
          createdDeliveries => {
            const {
              createdOrderCount,
              errorDeliveriesByRequestID,
            } = this.handleCreatedDeliveries(createdDeliveries);
            succeessCreatedOrderCount += createdOrderCount;
            errorsDeliveries = {
              ...errorsDeliveries,
              ...errorDeliveriesByRequestID,
            };
            const { placedBatchDeliveriesCount } = this.state;
            this.setState({
              placedBatchDeliveriesCount:
                placedBatchDeliveriesCount +
                createdDeliveries.deliveries.length,
            });
          },
        );
      }

      this.setState({
        isCreatingOrders: false,
        placedBatchDeliveriesCount: 0,
        batchedDeliveriesCount: 0,
      });
      this.handleCreatedOrders(succeessCreatedOrderCount, errorsDeliveries);
    });
  };

  onOrdersPlaced = (succeessCreatedOrderCount, userInfo) => {
    if (!succeessCreatedOrderCount) return;

    const { history } = this.props;
    const notificationID = `BULK_BOOKING_SUCCESS_${succeessCreatedOrderCount}`;

    addNotification({
      id: notificationID,
      type: NOTIFICATION_TYPE.SUCCESS,
      title:
        succeessCreatedOrderCount === 1
          ? I18n.t(
              'v2.homepage.manualOrder.notification.createOrderSuccessful.title.one',
            )
          : I18n.t(
              'v2.homepage.manualOrder.notification.createOrderSuccessful.title.other',
              {
                amt: succeessCreatedOrderCount,
              },
            ),
      content: (
        <h5 className={css.createOrderSuccessNotif}>
          {I18n.t(
            'v2.homepage.manualOrder.notification.createOrderSuccessful.description',
          )}{' '}
          <span
            role="button"
            onKeyDown={null}
            onClick={() => {
              removeNotification(notificationID);
              history.push('/bookings');
            }}
          >
            {I18n.t(
              'v2.homepage.manualOrder.notification.createOrderSuccessful.descriptionLink',
            )}
          </span>
        </h5>
      ),
      duration: 10,
      onClick: () => {
        removeNotification(notificationID);
        history.push('/bookings');
      },
      clickable: true,
    });

    window.pushGAEvent({
      event: GA_EVENT.GE_TRANSACTION_SUCCESS,
      category: GA_CATEGORY.TRANSACTION,
      action: GA_ACTION.CREATE_BULK_BOOKING_SUCCESS,
      geTransactionType: BOOKING_TRANSACTION.BULK,
      geBulkVol: succeessCreatedOrderCount,
    });
    pushGAPageViewEvent('BOOKING_SUCCESS', userInfo, BOOKING_TRANSACTION.BULK);
  };

  getTotalAmountAndCurrency = () => {
    const { reviewOrders } = this.state;
    if (_isEmpty(reviewOrders)) return 0;

    let currency = {};
    const totalAmount = reviewOrders.reduce((acc, order) => {
      const { quote } = order;
      // skip adding order with quote errors
      if (_isEmpty(quote) || !_isEmpty(_get(quote, 'errors', []))) return acc;

      if (_isEmpty(currency)) currency = _get(quote, 'currency');
      return acc + _get(quote, 'amount', 0);
    }, 0);
    return {
      totalAmount,
      currency,
    };
  };

  getTotalAmountDisplay = () => {
    const { reviewOrders } = this.state;
    if (_isEmpty(reviewOrders)) return 0;

    const { totalAmount, currency } = this.getTotalAmountAndCurrency();
    if (totalAmount === 0 && _isEmpty(currency)) return totalAmount;

    return getAmountDisplay(totalAmount, currency, false);
  };

  getCreateOrderDeliveries = (orders, quotes, countryCode, cityCode) => {
    const { userInfo } = this.props;
    const quoteMap = getQuotaMap(quotes);
    const validDeliveries = orders.reduce(
      (acc, order) =>
        _isEmpty(order.errors) && isOrderWithValidQuote(order, quoteMap)
          ? acc.concat(
              getDeliveryDetails(
                order,
                quoteMap,
                countryCode,
                cityCode,
                userInfo,
              ),
            )
          : acc,
      [],
    );
    if (_isEmpty(validDeliveries)) {
      const ravenQuoteMap = JSON.stringify(quoteMap);
      const error = new Error(
        'Failed to getQuote due to not match serviceID in ReviewScreen',
      );
      const errorCtx = rumErrorCtx(getDefaultErrorContext())
        .component('BulkUploadPage')
        .severity(SEVERITY.MEDIUM)
        .custom('tags', {
          ravenQuoteMap,
          orders: JSON.stringify(orders),
        })
        .build();
      ddRum.addError(error, errorCtx);
      addNotification(NOTIFICATION_CONFIGS.review_err_try_again);
    }
    return validDeliveries;
  };

  handleCreatedOrders = (successCount, errorsDeliveries) => {
    let errMsg = '';
    const errorOrderCount = _keys(errorsDeliveries).length;
    const { userInfo } = this.props;

    this.onOrdersPlaced(successCount, userInfo);

    // TODO: display error orders and able to place order again
    if (errorOrderCount > 0) {
      errMsg =
        successCount === 0
          ? 'Failed to create any delivery'
          : 'Creating some orders have been failed';
      addNotification(
        customizedTextNotificationConfig(
          errMsg,
          `${classifyWord(
            'order',
            'orders',
            errorOrderCount === 1,
          )} failed to be created`,
        ),
      );
    } else if (successCount === 0) {
      // 0 order placed
      errMsg = 'Faild to place deliveries order';
      addNotification(
        customizedTextNotificationConfig(
          errMsg,
          NOTIFICATION_CONFIGS.err_bulk_booking_try_again.title,
        ),
      );
    }

    if (errMsg !== '') {
      const errorCtx = rumErrorCtx(getDefaultErrorContext())
        .component('BulkUploadPage')
        .severity(SEVERITY.MEDIUM)
        .custom('tags', {
          errorsDeliveries,
        })
        .build();
      ddRum.addError(new Error(errMsg), errorCtx);
    }

    // redirect to bookings page if any order placed;
    // redirect to home page if no order placed
    if (successCount > 0) {
      const { clearOrders, history } = this.props;
      clearOrders();
      history.push('/bookings');
    } else {
      const { onBackHome } = this.props;
      onBackHome();
    }
  };

  createOrderParams = (deliveries, userInfo) => {
    const result = {
      deliveries,
      bookingMode: BookingMode.Bulk,
    };
    if (!isUsingPaxPersonalPayments()) {
      result.enterprise = enterpriseForQuoteParam(userInfo);
    }
    return result;
  };

  handleCreatedDeliveries = createdDeliveries => {
    const errorDeliveriesByRequestID = {};
    const createdOrderCount = createdDeliveries.deliveries.reduce(
      (acc, order) => {
        if (!order.errors || _isEmpty(order.errors)) {
          return acc + 1;
        }
        errorDeliveriesByRequestID[order.createRequestID] = order;
        return acc;
      },
      0,
    );
    return { createdOrderCount, errorDeliveriesByRequestID };
  };

  filterValidItems = items =>
    items.filter(
      item =>
        _isEmpty(_get(item, 'errors', [])) &&
        _isEmpty(_get(item, 'quote.errors', [])) &&
        _isEmpty(_get(item, 'bookingLimit.errors', [])),
    );

  filterInvalidItems = items =>
    items.filter(
      item =>
        !_isEmpty(_get(item, 'errors', [])) ||
        !_isEmpty(_get(item, 'quote.errors', [])) ||
        !_isEmpty(_get(item, 'bookingLimit.errors', [])),
    );

  renderPercentageProcess = () => {
    const {
      isCreatingOrders,
      batchedDeliveriesCount,
      placedBatchDeliveriesCount,
    } = this.state;
    if (!isCreatingOrders || batchedDeliveriesCount === 0) return null;

    const percentage = Math.max(
      12, // initial progress to show user
      Math.ceil(100.0 * placedBatchDeliveriesCount / batchedDeliveriesCount),
    );
    const adjustedPercent = Math.min(100, percentage);
    return <Progress percent={adjustedPercent} status="active" />;
  };

  render() {
    const { onClickBack, userInfo, showFailedPaymentsRetryModal } = this.props;
    const {
      visibleSelectPOIModal,
      visibleUpdateErrFieldModal,
      visibleColumns,
      statusFilter,
      reviewOrders,
      fetchingQuote,
      isCreatingOrders,
    } = this.state;
    const validItems = this.filterValidItems(reviewOrders);
    const invalidItems = this.filterInvalidItems(reviewOrders);
    const disableReviewButton =
      isCreatingOrders || fetchingQuote || validItems.length < 1;

    let reviewItems;
    if (statusFilter === STATUS_FILTERS.ALL) {
      reviewItems = reviewOrders;
    } else if (statusFilter === STATUS_FILTERS.INVALID) {
      reviewItems = invalidItems;
    } else {
      reviewItems = validItems;
    }

    const visibleColSelectOptions = _reduce(
      TABLE_COLUMN_V2,
      (result, v, k) => {
        if (TABLE_COLUMN_V2_MUST_SHOW.includes(k)) return result;

        result.push({
          value: k,
          title: I18n.t(v.value),
          key: k,
        });
        return result;
      },
      [],
    );
    const visibleColSelectDefaultValues = visibleColSelectOptions.map(
      o => o.key,
    );

    let updateErrFieldOriginalValue = null;
    if (this.editingErrorOrder) {
      const { orderIndex, fieldKey, itineraryIndex } = this.editingErrorOrder;
      updateErrFieldOriginalValue = getUpdateErrFieldOriginalValue(
        reviewOrders,
        orderIndex,
        fieldKey,
        itineraryIndex,
      );
      // if (isNaN(updateErrFieldOriginalValue))
      //   updateErrFieldOriginalValue = 'NaN';
    }

    return (
      <div>
        <BackButton onClick={onClickBack} />
        <h4 className={css.pageHeader}>
          {I18n.t('v2.homepage.uploadOrder.reviewTable.heading')}
        </h4>
        <div className={css.reviewPanel}>
          <div className={css.reviewSummary}>
            <div className={css.summaryText}>
              <h5>
                {I18n.t('v2.homepage.uploadOrder.reviewTable.uploadedOrders', {
                  amt: reviewOrders.length,
                })}
              </h5>
              <h6>
                {I18n.t(
                  'v2.homepage.uploadOrder.reviewTable.uploadedOrdersDetail',
                  {
                    ready: validItems.length,
                    attention: invalidItems.length,
                    count: invalidItems.length,
                  },
                )}
              </h6>
            </div>
            <Button
              className={css.reviewOrderButton}
              type="primary"
              onClick={this.onClickBookDeliveries}
              disabled={disableReviewButton}
            >
              <div className={css.childWrap}>
                <div>
                  <h6>
                    {I18n.t(
                      'v2.homepage.uploadOrder.reviewTable.bookOrder.other',
                      {
                        amt: validItems.length,
                      },
                    )}
                  </h6>
                  <h5>{this.getTotalAmountDisplay()}</h5>
                </div>
                <Icon type="right" />
              </div>
            </Button>
          </div>
          <div className={css.reviewTable}>
            <div
              className={
                isCreatingOrders
                  ? classnames(css.reviewTableFilter, css.hidden)
                  : css.reviewTableFilter
              }
            >
              <MultipleSelect
                disabled={isCreatingOrders}
                placeholder="Show or hide columns"
                defaultValue={visibleColSelectDefaultValues}
                options={visibleColSelectOptions}
                onSelectionChange={this.onVisibleColumnsChanged}
                mustSelectValue={[]}
              />
              <Select
                disabled={isCreatingOrders}
                defaultValue={STATUS_FILTERS.ALL}
                onChange={this.onStatusFilterChange}
                style={{
                  width: 200,
                }}
              >
                <Option key={STATUS_FILTERS.ALL} value={STATUS_FILTERS.ALL}>
                  {I18n.t('v2.homepage.uploadOrder.filter.allStatus')}
                </Option>
                <Option key={STATUS_FILTERS.VALID} value={STATUS_FILTERS.VALID}>
                  {I18n.t('v2.homepage.uploadOrder.filter.ready')}
                </Option>
                <Option
                  key={STATUS_FILTERS.INVALID}
                  value={STATUS_FILTERS.INVALID}
                >
                  {I18n.t('v2.homepage.uploadOrder.filter.needAttention')}
                </Option>
              </Select>
            </div>
            {this.renderPercentageProcess()}
            <div className={isCreatingOrders ? css.hidden : null}>
              <BulkReviewTable
                reviewItems={reviewItems}
                onClickRepickLocation={this.onClickRepickLocation}
                onDeleteRecord={this.onDeleteRecord}
                visibleColumns={visibleColumns}
                onEditErrorField={this.onEditErrorField}
                onRetryFailedPayments={showFailedPaymentsRetryModal}
              />
            </div>
          </div>
        </div>
        <SelectLocationModal
          visible={visibleSelectPOIModal}
          userInfo={userInfo}
          addressEntity={
            _get(this.editingAddressOrder, 'originalAddressEntity') || {}
          }
          originalAddressEntity={
            _get(this.editingAddressOrder, 'originalAddressEntity') || {}
          }
          isSender={_get(this.editingAddressOrder, 'isSender', false)}
          onClickCancelRepickLocation={this.onClickCancelRepickLocation}
          onClickUpdateRepickLocation={this.onClickUpdateRepickLocation}
        />
        <ReviewOrderEditModal
          visible={visibleUpdateErrFieldModal}
          editingFieldKey={_get(this.editingErrorOrder, 'fieldKey')}
          originalValue={updateErrFieldOriginalValue}
          onSaveEditCallback={this.onEditErrorFieldSave}
          onCancelEditCallback={this.onCancelEditErrorField}
        />
      </div>
    );
  }
}

BulkUploadPage.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  initReviewParams: PropTypes.shape({
    reviewOrders: PropTypes.arrayOf(PropTypes.shape({})),
    quoteParam: PropTypes.shape({}),
    serviceTypeMap: PropTypes.shape({}),
    paymentMethodMap: PropTypes.shape({}),
    addressMap: PropTypes.shape({}),
  }),
  history: PropTypes.shape({}).isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  fetchQuotes: PropTypes.func.isRequired,
  createOrder: PropTypes.func.isRequired,
  clearOrders: PropTypes.func.isRequired,
  onBackHome: PropTypes.func.isRequired,
  showFailedPaymentsRetryModal: PropTypes.func.isRequired,
  scribeExpressBulkUploadReviewDefault: PropTypes.func.isRequired,
  scribeExpressBulkUploadReviewEditAddress: PropTypes.func.isRequired,
};

BulkUploadPage.defaultProps = {
  onClickBack: null,
  initReviewParams: {
    reviewOrders: [],
    quoteParam: {},
    serviceTypeMap: {},
    paymentMethodMap: {},
    addressMap: {},
  },
};

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
});

const mapDispatchToProps = {
  createOrder: createOrderAction,
  fetchQuotes: getQuotesAction,
  fetchServiceTypes: fetchServiceTypesAction,
  fetchAddressTranslate: getAddressTranslationAction,
  fetchPaymentMethods: getPaymentMethodsAction,
  fetchAddressSearch: getAddressSearchAction,
  clearOrders: clearOrdersActionV2,
  showFailedPaymentsRetryModal: showFailedPaymentsRetryModalAction,
  scribeExpressBulkUploadReviewDefault:
    ScribeDuck.creators.scribeExpressBulkUploadReviewDefault,
  scribeExpressBulkUploadReviewEditAddress:
    ScribeDuck.creators.scribeExpressBulkUploadReviewEditAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkUploadPage);
